import type { RootState } from '~/store';

// Base selector
export const clanRenameSelector = (state: RootState) => ({
  name: state.clanRename.name,
  tag: state.clanRename.tag,
  isProcessing: state.clanRename.isProcessing,
  error: state.clanRename.error,
});

export const clanRenameIsProcessingSelector = (state: RootState) => state.clanRename.isProcessing;
